import util from '../utils';

const DISCONNECT_REASON = {
  IO_SERVER_DISCONNECT: 'io server disconnect',
  IO_CLIENT_DISCONNECT: 'io client disconnect',
  PING_TIMEOUT: 'ping timeout',
};

export default [
  {
    key: 'connect_error',
    listener: error => {
      util.log.p(`client connect error happens: ${error}`);
    },
  },
  {
    key: 'connect_timeout',
    listener: timeout => {
      util.log.p(`client connect timeout: ${timeout}`);
    },
  },
  {
    key: 'error',
    listener: error => {
      util.log.p(`client error happens: ${error}`);
    },
  },
  {
    key: 'disconnect',
    listener: reason => {
      switch (reason) {
        case DISCONNECT_REASON.IO_SERVER_DISCONNECT:
          break;
        case DISCONNECT_REASON.IO_CLIENT_DISCONNECT:
          break;
        case DISCONNECT_REASON.PING_TIMEOUT:
          break;
        default:
          break;
      }
    },
  },
  {
    key: 'reconnect',
    listener: attemptNumber => {
      util.log.p(`client reconnect attemptNumber: ${attemptNumber}`);
    },
  },
  {
    key: 'reconnect_attempt',
    listener: attemptNumber => {
      util.log.p(`client reconnect attempt attemptNumber: ${attemptNumber}`);
    },
  },
  {
    key: 'reconnecting',
    listener: attemptNumber => {
      util.log.p(`client reconnecting attemptNumber: ${attemptNumber}`);
    },
  },
  {
    key: 'reconnect_error',
    listener: error => {
      util.log.p(`client reconnect error happends: ${error}`);
    },
  },
  {
    key: 'reconnect_failed',
    listener: error => {
      util.log.p(`client reconnect failed: ${error}`);
    },
  },
  {
    key: 'ping',
    listener: () => {
      util.log.p(`client ping happends`);
    },
  },
  {
    key: 'pong',
    listener: () => {
      util.log.p(`client pong happends`);
    },
  },
];
